import Sidebar from "./Sidebar";
import MobileNav from "./MobileNav";

export default function AppShell({ children }) {
    return (
        <div
            className="h-screen w-full flex flex-col md:flex-row bg-[#050505] text-[#FAFAFA] overflow-hidden"
            data-testid="app-shell"
        >
            <Sidebar />
            <main className="flex-1 overflow-y-auto pb-20 md:pb-0">
                {children}
            </main>
            <MobileNav />
        </div>
    );
}
